module.exports = __webpack_public_path__ + "img/info-circle.11eb1d55.svg";